import { render, staticRenderFns } from "./GuestBook.vue?vue&type=template&id=24ea1aed&"
import script from "./GuestBook.vue?vue&type=script&lang=js&"
export * from "./GuestBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports